var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"facewrapper"}}),_c('div',{attrs:{"id":"downloadBox"}}),_c('el-button',{on:{"click":_vm.stopRecord}},[_vm._v("停止")]),_c('el-button',{on:{"click":_vm.startRecord}},[_vm._v("开始录制")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }